export const API_PATH_START_PLANOGRAM_REVIEW_SESSION = '/planogram-reviews/start-session';
export const API_PATH_END_PLANOGRAM_REVIEW_SESSION = '/planogram-reviews/end-session';
export const API_PATH_PLANOGRAM_REVIEW_SESSION_TASKS = '/planogram-reviews/session-tasks';
export const API_PATH_PLANOGRAM_REVIEW_ASSIGNED_TASK = '/planogram-reviews/task';
export const API_PATH_PLANOGRAM_REVIEW_BY_ID = '/planogram-reviews/:planogramUpdateReviewId';
export const API_PATH_PLANOGRAM_REVIEW_SKIP = '/planogram-reviews/:planogramUpdateReviewId/skip';
export const API_PATH_PLANOGRAM_REVIEWS_VALIDATED = '/planogram-reviews/validated';
export const API_PATH_PLANOGRAM_REVIEW_VALIDATED_BY_ID = '/planogram-reviews/validated/:reviewId';
export const API_PATH_PLANOGRAM_REVIEWS_STATUS = '/planogram-reviews/status';
export const API_PATH_PLANOGRAM_ITEMS_BY_SHELF = '/planogram-items/shelf/:shelfId';
export const API_PATH_PLANOGRAM_ITEMS_FIND = '/planogram-items/find';
export const API_PATH_PLANOGRAM_ITEMS_BY_GONDOLA = '/planogram-items/gondola/:gondolaId';
export const API_PATH_SHELF_BY_ID = '/shelves/:shelfId';
export const API_PATH_PLANOGRAM_PRODUCT_CANDIDATES_BY_STORE = '/products/planogram-candidates/store/:storeId';
export const API_PATH_DATASET_REVIEWS = '/dataset-reviews';

export const PLANOGRAM_REVIEW_SESSION_STORAGE_KEY = 'planogramReviewSessionActive';
export const PLANOGRAM_TICKET_VALIDATION_STORAGE_KEY = 'planogramTicketValidationState';
export const PLANOGRAM_REVIEW_STATUS_REFETCH_INTERVAL = 15_000; // 15 seconds

// Matches the backend's planogram work-session TTL: a session auto-ends after this long without
// a task being resolved or skipped. A ticket's validation duration should never exceed this,
// since ticket tracking is cleared on every session start/end. If it does, treat it as a sign of
// leaked tracking state rather than a real duration.
export const PLANOGRAM_WORK_SESSION_TTL_SECONDS = 15 * 60; // 15 minutes

/** Minimum width (in shelf millimeters) a planogram section may have. */
export const MIN_SECTION_WIDTH_MM = 10;

export const DEFAULT_VALIDATED_TASKS_PAGE_SIZE = 20;

// Safety margin (ms) applied on both sides of a review's validationTimestamp. Subtracted for
// "before", added for "after", when sampling the shelf's point-in-time state.
export const PLANOGRAM_HISTORIC_TIMESTAMP_MARGIN_MS = 5_000;

export const QUERY_KEYS = {
  PLANOGRAM_REVIEW_TASKS: 'planogram-review-tasks',
  PLANOGRAM_ITEMS_BY_SHELF: 'planogram-items-by-shelf',
  PLANOGRAM_PRODUCT_CANDIDATES: 'planogram-product-candidates',
  PLANOGRAM_VALIDATED_TASKS: 'planogram-validated-tasks',
  PLANOGRAM_REVIEW_STATUS: 'planogram-review-status',
  PLANOGRAM_VALIDATED_REVIEW_DETAIL: 'planogram-validated-review-detail',
  SHELF_GONDOLA_ID: 'shelf-gondola-id',
  PLANOGRAM_ITEMS_BY_GONDOLA_AT_TIMESTAMP: 'planogram-items-by-gondola-at-timestamp',
};
